var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wm",staticClass:"security-watermark",attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }